import { render, staticRenderFns } from "./HomePageAbout.vue?vue&type=template&id=a8858326&scoped=true&"
var script = {}
import style0 from "./HomePageAbout.vue?vue&type=style&index=0&id=a8858326&lang=scss&scoped=true&"
import style1 from "./HomePageAbout.vue?vue&type=style&index=1&id=a8858326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8858326",
  null
  
)

export default component.exports